/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import Tooltip from '@atlaskit/tooltip';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { useIntl } from 'react-intl-next';
import { messages } from '../i18n';
export var emojiErrorScreenreaderTestId = 'emoji-error-screenreader-message';
export var emojiErrorMessageTestId = 'emoji-error-message';
export var emojiErrorMessageTooltipTestId = 'emoji-error-message-tooltip';
export var emojiErrorIconTestId = 'emoji-error-icon';
var EmojiErrorMessage = function EmojiErrorMessage(props) {
  var messageStyles = props.messageStyles,
    message = props.message,
    tooltip = props.tooltip;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var visualContent = tooltip ?
  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
  jsx("div", {
    css: messageStyles,
    "data-testid": emojiErrorMessageTestId
  }, jsx(Tooltip, {
    content: message,
    position: "top",
    testId: emojiErrorMessageTooltipTestId
  }, jsx(ErrorIcon, {
    color: "currentColor",
    label: formatMessage(messages.error),
    LEGACY_size: "medium",
    spacing: "spacious",
    testId: emojiErrorIconTestId
  }))) :
  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
  jsx("div", {
    css: messageStyles,
    "data-testid": emojiErrorMessageTestId
  }, jsx(ErrorIcon, {
    color: "currentColor",
    label: formatMessage(messages.error),
    LEGACY_size: "small"
  }), message);
  return visualContent;
};
export default EmojiErrorMessage;